module.exports = __webpack_public_path__ + "img/Fa.efb038c3.png";